import { Router, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { OrdersModule } from './features/orders/orders-module';
import { authGuard } from './core/guards/auth-guard';
import { SessionService } from './core/services/session-service';

export const routes: Routes = [
  {
    // static import, not lazy: this is the landing screen, so it must not wait on a chunk
    path: '',
    canActivate: [authGuard],
    loadChildren: () => OrdersModule,
  },
  {
    path: 'login',
    loadComponent: () => import('./features/login/login').then((m) => m.Login),
  },
  {
    path: 'logout',
    canActivate: [
      () => {
        inject(SessionService).logout();
        return inject(Router).createUrlTree(['/login']);
      },
    ],
    children: [],
  },
  {
    path: 'users',
    canActivate: [authGuard],
    loadChildren: () => import('./features/users/users-module').then((m) => m.UsersModule),
  },
  {
    path: 'customers',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/customers/customers-module').then((m) => m.CustomersModule),
  },
  {
    path: 'promotions',
    canActivate: [authGuard],
    loadComponent: () => import('./features/promotions/promotions').then((m) => m.Promotions),
  },
  {
    path: 'database',
    canActivate: [authGuard],
    loadComponent: () => import('./features/database/database').then((m) => m.Database),
  },
  {
    path: 'documents',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/documents/documents-module').then((m) => m.DocumentsModule),
  },
  {
    path: 'payments',
    canActivate: [authGuard],
    loadChildren: () => import('./features/payments/payments-module').then((m) => m.PaymentsModule),
  },
  {
    // The dealer's own receipt, opened from an SMS link. Deliberately NOT behind authGuard:
    // dealers have no account, and the unguessable `key` query parameter is what authorizes
    // the read. Must stay above the wildcard or it would redirect to the dashboard.
    path: 'receipt/:receiptNo',
    data: { fullBleed: true },
    loadComponent: () => import('./features/receipt/receipt').then((m) => m.Receipt),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
